module.exports = __webpack_public_path__ + "static/media/logo-white.2f216b58.png";